import { UserHealthActivityStatus } from '@leagueplatform/health-journey-common';
import { ErrorContext, captureError } from '@leagueplatform/observability';
import { HealthActivityDeserializedData } from '../types/health-activity-response-data.type';

export const errorTitle = 'Corrupt Activity';

export const errorMessages = {
  status: `Activity status must be one of ${Object.values(
    UserHealthActivityStatus,
  ).join(', ')}`,
};

export const handleCorruptActivity = (
  activity: HealthActivityDeserializedData | HealthActivityDeserializedData[],
) => {
  // Handle specific edge case whereby an activity is in the process of being instantiated on the backend
  if (Array.isArray(activity)) {
    if (activity.length === 0) {
      throw new Error(
        'Health activity is still being prepared. Please try again.',
      );
    } else if (activity.length > 1) {
      // else do not handle multiple activities here (this is presumably intended by teams like CS)
      return;
    }
  }

  const activityDataObj = Array.isArray(activity) ? activity?.[0] : activity;
  const {
    status,
    id: userActivityId,
    activityId,
    type: activityType,
    userHealthCampaign,
  } = activityDataObj;
  const context: ErrorContext = {
    tags: { ownershipTeam: 'activities' },
    context: {
      activity: {
        userActivityId,
        activityId,
        activityType,
        userHealthCampaign: userHealthCampaign?.data,
      },
    },
  };

  let error = null;
  if (!status) {
    error = new Error(errorMessages.status);
  }

  if (error) {
    error.name = errorTitle;
    captureError(error, context);
    throw error;
  }
};
